export default {
  apiNotAvailable: 'NPM API nedostupné',
  systemKnown: 'Systém je NPM API známy',
  systemUnknown: 'Systém je NPM API neznámy',
};
